import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-1" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs flex flex-row space-x-1 items-center my-2 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, " If you need to clarify something about this section in job detail, please add a comment here. ")
], -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "w-5/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeLine = _resolveComponent("TimeLine")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TimeLine)
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TextField, {
          class: _normalizeClass('default'),
          modelValue: _ctx.comment,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
          label: "Write your comment here",
          name: "comment"
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            variant: "contained",
            type: "submit",
            label: "Send",
            disabled: !_ctx.meta.valid
          }, null, 8, ["disabled"])
        ])
      ])
    ], 32)
  ], 64))
}